import React, { memo } from 'react';
import { Switch, Route } from 'react-router-dom';
import { map } from 'lodash';
import PageNotFound from '../../../shared/components/PageNotFound/PageNotFound';
import RouteWithSubRoutesContainer from '../../../app/containers/RouteWithSubRoutesContainer';
import styles from './index.module.scss';

export default memo(function Index(props) {
    return (
        <div className={styles.container}>
            <Switch>
                {map(props.routes, route => <RouteWithSubRoutesContainer key={route.path} {...route} />)}
                <Route component={PageNotFound} />
            </Switch>
        </div>
    )
});
